<ng-container class="lesson">
  <header class="lesson-header row">
    <div class="col-8">
      <h1>Practice Questions</h1>
      @if (hint) {
        <h3>HINT: {{hint}}</h3>
      }
    </div>
    <div class="col-4 lesson-smartsavers">
      <p class="lead">Smartsavers</p>
      <ul class="list-unstyled list-inline pull-right">
        @if (isHintEnable) {
          <li class="list-inline-item">
            #
            <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Get Hint"
              (click)="onGetHint()">
              <i class="fa fa-puzzle-piece"></i>
            </button>
          </li>
        }
        <li class="list-inline-item">
          #
          <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Cut Incorrect"
            (click)="onCutIncorrect()">
            <i class="fa fa-scissors"></i>
          </button>
        </li>
        <li class="list-inline-item">
          #
          <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Skip"
            (click)="onSkip()">
            <i class="fa fa-forward"></i>
          </button>
        </li>
        @if (isStopTimerEnable && !isPersistence) {
          <li class="list-inline-item">
            #
            <button class="btn btn-primary btn-sm" placement="bottom" ngbTooltip="Stop timer"
              (click)="onPauseTimer()">
              <i class="fa fa-clock-o"></i>
            </button>
          </li>
        }
      </ul>
    </div>
  </header>

  <app-problem-multiple-choice-container-orig
    (onNext)="handleNext()"
    (onRestartTimer)="restartTimer()"
    (onStopTimer)="stopTimer()"
    [discardedOptions]="discardedOptions"
    [isPersistences]="isPersistence">
  </app-problem-multiple-choice-container-orig>

  @if (!isPersistence) {
    <div class="lesson-goals">
      <div class="row">
        <div class="col-6">
          <i class="fa fa-bullseye"></i>
          <div class="progress">
            <div class="progress-bar progress-bar-striped" role="progressbar"
              style="height: 1.5rem; line-height: 1.5rem" aria-valuenow="20" aria-valuemin="0"
              [style.width.%]="exerciseProgressWidth"
              aria-valuemax="100">{{exerciseProgressWidth}}%
            </div>
          </div>
        </div>
        <div class="col-6">
          <i class="fa fa-stopwatch"></i>
          <ng-container>
            {{ currentTime | time}}
          </ng-container>
          <div class="progress">
            <div class="w-50">
              <div class="progress-bar progress-bar-striped bg-primary progress-bar-fast" role="progressbar"
                [style.width.%]="fasterWidth"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="50">
              </div>
            </div>
            <div class="w-50">
              <div class="progress-bar progress-bar-striped bg-danger progress-bar-slow" role="progressbar"
                [style.width.%]="slowerWidth"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="50">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
